export const BrokerCostType = Object.freeze({
  Property: 'Property',
  Liability: 'Liability',
  Person: 'Person',
  Transport: 'Transport',
  Casco: 'Casco',
  PersonalCommission: 'PersonalCommission',
  MotorCommission: 'MotorCommission',
});
